/**
 * Product Lists Section
 * Handles tab navigation and Swiper sliders for multiple product collections
 */

(function() {
  'use strict';

  const SELECTORS = {
    section: '[data-section-type="product-lists"]',
    tab: '.product-lists__tab',
    collection: '.product-lists__collection',
    slider: '.product-lists__slider'
  };

  const CLASSES = {
    tabActive: 'product-lists__tab--active',
    collectionActive: 'product-lists__collection--active'
  };

  class ProductLists {
    constructor(section) {
      this.section = section;
      this.tabs = section.querySelectorAll(SELECTORS.tab);
      this.collections = section.querySelectorAll(SELECTORS.collection);
      this.swipers = [];
      this.currentTab = 0;

      this.init();
    }

    init() {
      this.initSliders();
      this.bindEvents();
    }

    initSliders() {
      this.collections.forEach((collection, index) => {
        const slider = collection.querySelector(SELECTORS.slider);
        if (!slider) return;

        const prevButton = collection.querySelector(`.product-lists-prev-${index}`);
        const nextButton = collection.querySelector(`.product-lists-next-${index}`);

        // Initialize Swiper for this collection
        const swiper = new Swiper(slider, {
          slidesPerView: 'auto',
          spaceBetween: 4,
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
          breakpoints: {
            990: {
              slidesPerView: 'auto',
              spaceBetween: 8,
            }
          },
          watchOverflow: true,
          observer: true,
          observeParents: true,
          observeSlideChildren: true
        });

        this.swipers.push(swiper);
      });
    }

    bindEvents() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.switchTab(index));
      });
    }

    switchTab(index) {
      if (index === this.currentTab) return;

      // Update tabs
      this.tabs.forEach((tab, i) => {
        if (i === index) {
          tab.classList.add(CLASSES.tabActive);
        } else {
          tab.classList.remove(CLASSES.tabActive);
        }
      });

      // Update collections
      this.collections.forEach((collection, i) => {
        if (i === index) {
          collection.classList.add(CLASSES.collectionActive);
        } else {
          collection.classList.remove(CLASSES.collectionActive);
        }
      });

      // Update current tab
      this.currentTab = index;

      // Update swiper for the active collection
      if (this.swipers[index]) {
        setTimeout(() => {
          this.swipers[index].update();
        }, 100);
      }
    }

    destroy() {
      // Destroy all swipers
      this.swipers.forEach(swiper => {
        if (swiper && swiper.destroy) {
          swiper.destroy(true, true);
        }
      });
      this.swipers = [];
    }
  }

  // Initialize sections
  function initSections() {
    const sections = document.querySelectorAll(SELECTORS.section);
    sections.forEach(section => {
      new ProductLists(section);
    });
  }

  // Init on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSections);
  } else {
    initSections();
  }

  // Shopify Theme Editor support
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const section = event.target.querySelector(SELECTORS.section);
      if (section) {
        new ProductLists(section);
      }
    });

    document.addEventListener('shopify:section:unload', function(event) {
      const section = event.target.querySelector(SELECTORS.section);
      if (section && section.productListsInstance) {
        section.productListsInstance.destroy();
      }
    });

    document.addEventListener('shopify:block:select', function(event) {
      const section = event.target.closest(SELECTORS.section);
      if (!section) return;

      const blockId = event.detail.blockId;
      const tabs = section.querySelectorAll(SELECTORS.tab);

      tabs.forEach((tab, index) => {
        if (tab.dataset.blockId === blockId) {
          const instance = section.productListsInstance;
          if (instance) {
            instance.switchTab(index);
          }
        }
      });
    });
  }
})();
